import React from 'react'
import { useIntl } from 'react-intl'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import Group from 'components/utils/Group'
import moment from 'moment'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import type { MappedRequestAgentCallbackResult } from './RequestAgentCallbackModal'

interface Props {
  customer: MappedRequestAgentCallbackResult['customer']
}

export function RequestAgentCallbackConfirmationModal(props: Props) {
  const intl = useIntl()
  const { callbackTime, callbackDate, email } = props.customer
  return (
    <ModalBase>
      <form>
        <ModalHeader title={intl.formatMessage({
          id: 'u8zuyfZA+E',
          defaultMessage: 'Callback request sent',
          description: 'Title for callback request confirmation modal',
        })}
        />
        <ModalBody>
          <ModalContent>
            <VerticalSpacer gap={20}>
              <Group direction="vertical" gap={20}>
                <BodyTextBlock variant="large">
                  {intl.formatMessage({
                    id: 'FDhpjR3ls7',
                    defaultMessage: 'A customer service agent will call you at',
                    description: 'Text preceding callback time and date details',
                  })}
                </BodyTextBlock>
                <Group direction="vertical" gap={0}>
                  <BodyTextBlock variant="large" weight="bold">
                    {intl.formatMessage(
                      {
                        id: '3KJKlsvWHU',
                        defaultMessage: 'Time: {callbackTime}',
                        description: 'Callback time label with scheduled time value',
                      },
                      { callbackTime },
                    )}
                  </BodyTextBlock>
                  <BodyTextBlock variant="large" weight="bold">
                    {intl.formatMessage(
                      {
                        id: '0+ZxxQmon6',
                        defaultMessage: 'Date: {callbackDate}',
                        description: 'Callback date label with scheduled date value',
                      },
                      { callbackDate: moment(callbackDate).format(DMY_CASUAL_FORMAT) },
                    )}
                  </BodyTextBlock>
                </Group>
                <BodyTextBlock variant="large">
                  {intl.formatMessage(
                    {
                      id: 'iVghxqNNfz',
                      defaultMessage: 'A confirmation email has been sent to {email}.',
                      description: 'Confirmation message showing email address where callback confirmation was sent',
                    },
                    { email },
                  )}
                </BodyTextBlock>
              </Group>
            </VerticalSpacer>
          </ModalContent>
        </ModalBody>
        <ModalFooter primaryActionProps={{
          children: intl.formatMessage({
            id: 'kAFqJ0X2U1',
            defaultMessage: 'Close',
            description: 'Close button for callback confirmation modal',
          }),
        }}
        />
      </form>
    </ModalBase>
  )
}
